import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import {TaskService} from '../../services/task.service';
@Component({
  selector: 'nf-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.css']
})
export class IntegrationComponent implements OnInit {
  type: string; // 存放当前类型 integrations 集成 automations 自动化
  dataSubscription: Subscription = null;
  categoryList: Array<any> = []; // 菜单目录
  menuId: number; // 存放当前菜单ID
  isVisible = false;
  @Input('nfType') set changeType(data: string) {
    if (data) {
      this.type = data;
    }
  }
  constructor(
    private taskService: TaskService
  ) { }

  ngOnInit() {
    this.getData();
  }
  // 获取集成数据
  getData() {
    this.dataSubscription = this.taskService.getIntegrationData({}).subscribe((res: any) => {
      if (res) {
        const data = res;
        if (data.hasOwnProperty('categories')) {
          data.categories.forEach((item, index) => {
            if (item.entity === this.type) {
              this.categoryList.push(item);
            }
          });
        }
        this.menuId = this.categoryList[0].id;
      }
    });
  }
  // 菜单点击事件
  handleMenuChange(id) {
   this.menuId = id;
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
}
